import { Text, Title } from "@mantine/core";

import { mightierColors } from "@config/colors/colors";

export const Text12Medium = Text.withProps({ fz: "12px", fw: 500 });
export const Text16Medium = Text.withProps({ fz: "16px", fw: 500 });

export const Title3 = Title.withProps({ order: 3 });
export const Title5 = Title.withProps({ order: 5 });

export const SpringOnboardingText = Text.withProps({
  c: mightierColors.royal100,
});

export const SpringOnboardingTitle = Title.withProps({
  c: mightierColors.royal100,
});
